import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import { useField } from 'formik';
import { NvTextArea, NvInput } from '@invitae/ids-react';

var NvFormikInput = function (_a) {
    var as = _a.as, helperText = _a.helperText, props = __rest(_a, ["as", "helperText"]);
    var _b = __read(useField(props), 3), meta = _b[1], helpers = _b[2];
    var error = meta.touched && !!meta.error;
    var value = meta.value;
    var handleChange = React__default.useCallback(function (e) {
        var value = e.target.value;
        helpers.setValue(value);
    }, [helpers]);
    var allProps = __assign(__assign({}, props), { error: error, helperText: error ? meta.error : helperText, onChange: handleChange, value: value });
    if (as === 'textarea') {
        return React__default.createElement(NvTextArea, __assign({}, allProps));
    }
    return React__default.createElement(NvInput, __assign({}, allProps));
};
// eslint-disable-next-line react/no-multi-comp
var NvFormikTextarea = function (props) {
    return React__default.createElement(NvFormikInput, __assign({}, props, { as: "textarea" }));
};

export { NvFormikTextarea, NvFormikInput as default };
//# sourceMappingURL=NvFormikInput.esm.js.map
